<template>
	<div class="customer-profile-listing">
		<base-header class="pb-6">
			<b-row align-v="center" class="py-3">
				<b-col cols="6">
					<p class="text-muted">Profile</p>
					<h2 class="listing-title d-inline-block mb-0">Initial Proposal</h2>
				</b-col>
			</b-row>
		</base-header>
		<b-container fluid class="mt--6">
			<b-card no-body class="p-4">
				<div class="customer-listing-table">
					<!-- MAIN STATUS -->
					<b-row class="mb-4 mx-0 filter-buttons">
						<b-col cols="6" md="auto" class="px-1">
							<b-button block  :variant="selectedButton === 'All' ? 'primary' : 'outline-primary'" class="mb-2 mr-2 shadow-none"
								@click="selectButton(null)">
								All<br/>
								<span class="font-weight-600"> {{ proposalSummaryTotal }}</span>
							</b-button>
						</b-col>
						<b-col cols="6" md="auto" class="px-1" v-for="(item, index) in proposalSummary" :key="index">
							<b-button block :variant="selectedButton === item.psal_approval_codes ? 'primary' : 'outline-primary'"
								class="mb-2 mr-2 shadow-none" @click="selectButton(item.psal_approval_codes)">
								{{ item.label }}<br/>
								<span class="font-weight-600">{{ item.qty }}</span>
							</b-button>
						</b-col>
					</b-row>
					<InitialProposalTable :is_loading_table="is_loading_table"/>
				</div>
			</b-card>
		</b-container>
		<LoadingPage :is_loading="is_loading_page" />
	</div>
</template>
<script>
import InitialProposalTable from '@/views/InitialProposal/InitialProposalTable'
import LoadingPage from '@/components/LoadingPage'
import { mapActions, mapState } from 'pinia'
import { useInitialProposalStore } from '@/stores/initialProposalStore'
import initialProposalEventBus from '@/assets/js/EventBus/initialProposalEventBus.js'

export default {
	components: {
		LoadingPage,
		InitialProposalTable
	},
	data() {
		return {
			tableData: [],
			allTableData: [],
			is_loading_page: false,
			is_loading_table: false,
			selectedButton: 'All',
		}
	},
	created() {
		if(this.$route.query.page > 0)
		{
			this.setCurrentPage(this.$route.query.page)
		}

		if (_gHlp.isEmpty(this.filterQuery)) {
			history.pushState({}, null, this.$route.path + '?page=' + this.proposalPagination.page)
		}
		this.refreshProposalList();
	},
	mounted(){
			initialProposalEventBus.$on('refresh-proposals', this.fetchProposalList)
			initialProposalEventBus.$on('filter-proposals', this.filterProposalList)
	},
	beforeUnmount(){
			initialProposalEventBus.$off('refresh-proposals', this.fetchProposalList)
			initialProposalEventBus.$off('filter-proposals', this.filterProposalList)
	},
	computed: {
		...mapState(useInitialProposalStore,['proposalPagination', 'proposalList', 'proposalSummary', 'proposalSummaryTotal', 'proposalMeta', 'filterQuery']),
	},
	methods: {
		...mapActions(useInitialProposalStore, ['getProposalList','getProposalListSummary','setCurrentPage','setFilter']),
		async refreshProposalList(){
			this.is_loading_page = true;
			await this.fetchProposalList();
			this.getProposalListSummary();
			this.is_loading_page = false;
		},
		async filterProposalList(){
			this.is_loading_table = true;
			await this.fetchProposalList();
			this.getProposalListSummary();
			this.is_loading_table = false;
		},
		async fetchProposalList(){
			await this.getProposalList();
		},
		async selectButton(filter_approval_codes) {
			this.selectedButton = filter_approval_codes;
			if(!_gHlp.isEmpty(filter_approval_codes)){
				this.setFilter({psal_approval_code:filter_approval_codes});
			}else{
				this.setFilter({psal_approval_code:null});
			}
			this.is_loading_table = true;
			await this.fetchProposalList();
			this.is_loading_table = false;
		},
	}
}
</script>